import { CEAssessmentAttributesBase } from './ce-assessment-attributes-base'


export class CEAssessmentAttributes extends CEAssessmentAttributesBase {

}